export const dotSize = 5;
export const gapSize = 5;
export const activeDotSize = 18;

export const dotSizeV2 = 8;
export const gapSizeV2 = 6;
export const activeDotSizeV2 = 40;

